export default __webpack_public_path__ + "static/media/claims_pro_logo_color.b5cca2ae.svg";